import actions from './actions';

const {
	
	FETCH_CREDIT_BEGIN,
	FETCH_CREDIT_SUCCESS,
	FETCH_CREDIT_ERR,

	FETCH_HISTORY_BEGIN,
	FETCH_HISTORY_SUCCESS,
	FETCH_HISTORY_ERR,

} = actions;

const initialStateFilter = {
	data: null,
	list: null,
	loading: false,
	error: null,
};

const creditReducer = (state = initialStateFilter, action) => {
	const { type, data, err } = action;
	switch (type) {
		case FETCH_CREDIT_BEGIN:
			return {
				loading: true,
				error: null,
			};
		case FETCH_CREDIT_SUCCESS:
			return {
				data: data,
				loading: false,
				error: null,
			};
		case FETCH_CREDIT_ERR:
			return {
				loading: false,
				error: err,
			};

		case FETCH_HISTORY_BEGIN:
			return {
				loading: true,
				error: null,
			};
		case FETCH_HISTORY_SUCCESS:
			return {
				list: data,
				loading: false,
				error: null,
			};
		case FETCH_HISTORY_ERR:
			return {
				loading: false,
				error: err,
			};

		default:
			return state;
	}
};

export default creditReducer;
